<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                      <!-- <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i> -->
                      <div class="flex-1">
                        <h3 class="m-0 text-info"><strong>Export</strong></h3>
                        <p class="mb-0">Jangan lupa backup ya gaes. Nanti bentuk exportnya jadi file excel ya</p>
                      </div>
                    </div>
                    <div class="card mt-3" v-if="!exportOpen">
                      <div class="card-body">
                        <h3>Maaf untuk sementara export hanya bisa jam 18.00 WIB ke atas</h3>
                      </div>
                    </div>
                    <div class="card mt-3" v-else>
                      <div class="card-body">
                        <div class="box-horizontal mb-0">
                          
                          <div class="mb-2">
                            <h3 class="m-0">Filter <span class="text-info"></span></h3>
                              <div class="mr-5">
                                <h4 class="m-0 text-info f-15 pointer" @click="dataAll.modalFilter = true">Pilih Filterisasi</h4>
                              </div>
                          </div>
                          
                          <div class="mb-2">
                            <h3 class="m-0">Bulan <span class="text-info"></span></h3>
                            <div class="box-horizontal m-0">
                              <div class="mr-2">
                                <h4 class="m-0 text-info f-15 pointer" @click="dataAll.modalBulan = true" v-text="dataAll.bulanFilterNama != null ? dataAll.bulanFilterNama : 'Pilih Bulan'">Pilih Bulan</h4>
                              </div>
                              <div class="mr-2">
                                <h4 class="m-0 text-info f-15 pointer" @click="dataAll.modalTahun = true" v-text="dataAll.tahunFilter">Pilih Tahun</h4>
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="col-md-12" v-show="dataAll.isCari">
                          Hasil : 
                          <span class="badge badge-secondary" v-show="dataAll.areaPilihNama != null">Area : {{dataAll.areaPilihNama}}</span> 
                          <span class="badge badge-secondary" v-show="dataAll.adminNama != null">Admin : {{dataAll.adminNama}}</span> 
                          <span class="badge badge-secondary" v-show="dataAll.paketNama != null">Paket : {{dataAll.paketNama}}</span> 
                          <span class="badge badge-secondary" v-show="dataAll.tanggal != null">Tanggal : {{tglIndo(dataAll.tanggal)}}</span> 
                          <button class="btn btn-sm btn-secondary" @click="btn.resetFilter">Reset</button>
                        </div>

                        <div class="mb-2">
                          <h4 class="m-0">Semua Pelanggan <span class="text-info"></span></h4>
                          <span v-show="dataAll.dataExportAll.length != 0">Data terdownload : {{ dataAll.dataExportAll.length }}</span>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="dataAll.exportAll = false, dataAll.pageExport = 0, btn.CariMulti('all')" v-show="dataAll.exportAll">EXPORT</button>
                            
                            <!--
                              :title      = "dataAll.judulDoc" 
                            -->

                            <download-excel v-show="dataAll.dataExportAllshow"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelangganOnly"
                              :fields     = "dataAll.json_fieldspelangganOnly"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>
                        <div class="mb-2">
                          <h4 class="m-0">Belum Bayar <span class="text-info"></span></h4>
                          <span v-show="dataAll.dataExportBelum.length != 0">Data terdownload : {{ dataAll.dataExportBelum.length }}</span>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="dataAll.exportBelum = false, dataAll.pageExport = 0, btn.CariMulti('belum')" v-show="dataAll.exportBelum">EXPORT</button>
                            
                            <download-excel v-show="dataAll.dataExportBelumshow"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelanggan"
                              :fields     = "dataAll.json_fieldspelanggan"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :title      = "dataAll.judulDoc"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>
                        <div class="mb-2">
                          <h4 class="m-0">Lunas Bayar <span class="text-info"></span></h4>
                          <span v-show="dataAll.dataExportLunasNow.length != 0">Data terdownload : {{ dataAll.dataExportLunasNow.length }}</span>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="dataAll.pageExport = 0, btn.CariMulti('lunasnow'), dataAll.exportLunasNow = false" v-show="dataAll.exportLunasNow">EXPORT</button>
                            
                            <download-excel v-show="dataAll.dataExportLunasNowShow"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelanggan"
                              :fields     = "dataAll.json_fieldspelanggan"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :title      = "dataAll.judulDoc"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>
                        <div class="mb-2">
                          <h4 class="m-0 pointer">Transaksi Cash <span class="text-info"></span></h4>
                          <span v-show="dataAll.dataExportLunas.length != 0">Data terdownload : {{ dataAll.dataExportLunas.length }}</span>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="dataAll.pageExport = 0, btn.CariMulti('lunas'), dataAll.exportLunas = false" v-show="dataAll.exportLunas">EXPORT</button>
                            
                            <download-excel v-show="dataAll.dataExportLunasShow"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelanggan"
                              :fields     = "dataAll.json_fieldspelanggan"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :title      = "dataAll.judulDoc"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>
                        <div class="mb-2">
                          <h4 class="m-0">Transaksi Online <span class="text-info"></span></h4>
                          <span v-show="dataAll.dataExportLunasOnline.length != 0">Data terdownload : {{ dataAll.dataExportLunasOnline.length }}</span>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="dataAll.pageExport = 0, btn.CariMulti('lunas_online'), dataAll.exportLunasOnline = false" v-show="dataAll.exportLunasOnline">EXPORT</button>
                            
                            <download-excel v-show="dataAll.dataExportLunasOnlineShow"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelanggan"
                              :fields     = "dataAll.json_fieldspelanggan"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :title      = "dataAll.judulDoc"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>
                        <div class="mb-2">
                          <h4 class="m-0 text-danger">Pelanggan Berhenti <span ></span></h4>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" v-show="dataAll.exportBerhenti" @click="btn.CariMulti('berhenti'), dataAll.exportBerhenti = false">EXPORT</button>
                            
                            <!--
                              :title      = "dataAll.judulDoc" 
                            -->
                            <download-excel v-show="dataAll.type == 'berhenti'"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelangganOnly"
                              :fields     = "dataAll.json_fieldspelangganOnly"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>

                        <!-- ISOLIR -->
                        <div class="mb-2">
                          <h4 class="m-0 text-danger">Pelanggan ISOLIR <span ></span></h4>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" v-show="dataAll.exportIsolir" @click="btn.CariIsolir('isolir'), dataAll.exportIsolir = false">EXPORT</button>
                            
                            <!--
                              :title      = "dataAll.judulDoc" 
                            -->
                            <download-excel v-show="dataAll.type == 'isolir'"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelangganOnly"
                              :fields     = "dataAll.json_fieldspelangganOnly"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>
                        <!-- ISOLIR END -->

                        <div class="mb-2">
                          <h3 class="m-0">Invoice Transaksi Online <span class="text-info"></span></h3>
                          <h4 class="m-0 f-15">Invoice Masuk</h4>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="btn.ExportMasuk(),dataAll.type='invoice'">Export Masuk</button>
                            
                            <download-excel v-show="dataAll.type == 'invoice'"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelangganinvoice"
                              :fields     = "dataAll.json_fieldspelangganinvoice"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :title      = "dataAll.judulDoc"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                          <h4 class="m-0 f-15">Invoice Withdraw</h4>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="btn.ExportWithdraw(),dataAll.type='withdraw'">Export Masuk</button>
                            
                            <download-excel v-show="dataAll.type == 'withdraw'"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapelangganinvoice"
                              :fields     = "dataAll.json_fieldspelangganinvoice"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :title      = "dataAll.judulDoc"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>
                          </div>
                        </div>
                        
                        <div class="mb-2">
                          <h3 class="m-0">Pembukuan <span class="text-info"></span></h3>
                          <h4 class="m-0 f-15">Pembukuan</h4>
                          <span v-show="dataAll.dataExportPembukuan.length != 0">Data terdownload : {{ dataAll.dataExportPembukuan.length }}</span>
                          <div class="box-horizontal">
                            <button class="btn btn-sm btn-info" @click="btn.Pembukuan(),dataAll.type='pembukuan'">Export Pembukuan</button>
                            
                            <download-excel v-show="dataAll.dataExportPembukuanShow"
                              style       = "padding: 0"
                              :data       = "dataAll.json_datapembukuan"
                              :fields     = "dataAll.json_fieldspembukuan"
                              worksheet   = "My Worksheet"
                              :before-generate = "btn.startDownload"
                              :title      = "dataAll.judulDoc"
                              :name       = "dataAll.nameDoc"
                            >
                            
                              <button type="button" class="btn btn-sm btn-success">DOWNLOAD EXPORT</button>
                            </download-excel>

                          </div>
                        </div>

                      </div>
                    </div>
                </div>
                
            </div>
        </div>

      <!-- MODAL FILTER -->
			<div class="modal" tabindex="-1" role="dialog" v-show="dataAll.modalFilter">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Filterisasi</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="dataAll.modalFilter = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12" style="height: 400px;overflow:auto">
                  <div class="row">
                      <div class="col-md-12">
                          <div class="form-group">
                              <div class="form-group">
                                  <label class="bmd-label-floating">Area</label>
                                  <select class="form-control" placeholder="Pilih Area..." v-model="dataAll.areaPilih">
                                      <option value="null" selected disabled>Pilih Area</option>
                                      <option v-for="(u, index) in dataAll.area" :value="u.id"  @click="btn.pilihArea(u.id,u.nama);">{{u.nama}}</option>
                                  </select>
                              </div>
                          </div>
                          <div class="form-group">
                              <div class="form-group">
                                <label class="bmd-label-floating">Tanggal Tagihan</label>
                                <vuejs-datepicker :format="theGet.customFormatter" placeholder="Tanggal..." style="width:100%" v-model="dataAll.tanggal"></vuejs-datepicker>
                              </div>
                          </div>
                          <div class="form-group">
                              <div class="form-group">
                                  <label class="bmd-label-floating">By Admin</label>
                                  <select class="form-control" placeholder="Pilih Admin..." v-model="dataAll.adminID">
                                      <option value="null" selected disabled>Pilih Admin</option>
                                      <option v-for="(u, index) in dataAll.admin" :value="u.id"  @click="btn.pilihAdmin(u.id,u.nama)">{{u.nama}}</option>
                                  </select>
                              </div>
                          </div>
                          <div class="form-group">
                              <div class="form-group">
                                  <label class="bmd-label-floating">Paket</label>
                                  <select class="form-control" placeholder="Pilih Area..." v-model="dataAll.paketID">
                                      <option value="null" selected disabled>Pilih Paket</option>
                                      <option v-for="(u, index) in dataAll.paket" :value="u.id" @click="btn.pilihPaket(u.id,u.nama)">{{u.nama}} - {{ribu(u.tarif)}}</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
							</div>
						</div>
            <div class="modal-footer">
              <button class="btn btn-secondary" @click="btn.resetFilter()">Reset Filter</button>
              <button class="btn btn-info" @click="dataAll.isCari = true, dataAll.modalFilter = false">Pilih Filter</button> <!-- CariMulti(); -->
            </div>
					</div>
				</div>
			</div>

      <!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="dataAll.modalBulan">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Pilih Bulan</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="dataAll.modalBulan = false">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive" style="height: 500px;overflow:auto;">
                    <table class="table">
                      <thead class=" text-info">
                        <th>Bulan</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr v-for="(u, index) in dataAll.bulan">
                          <td>{{ u.nama }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="btn.pilihBulan(u.id,u.nama),dataAll.modalBulan = false"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="dataAll.modalTahun">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Pilih Tahun</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="dataAll.modalTahun = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12">
                  <div class="table-responsive" style="height: 500px;overflow:auto;">
                    <table class="table">
                      <thead class=" text-info">
                        <th>Bulan</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>2025</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="dataAll.tahunFilter = '2025',dataAll.modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2026</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="dataAll.tahunFilter = '2026',dataAll.modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2027</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="dataAll.tahunFilter = '2027',dataAll.modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2028</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="dataAll.tahunFilter = '2028',dataAll.modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>2029</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="dataAll.tahunFilter = '2029',dataAll.modalTahun = false"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>


      </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
	components: { 
    vuejsDatepicker,
    "Loading" : Loading
	}, 
  setup() {
    const dataAll = reactive({
        exportIsolir: true,
        exportBerhenti: true,
        exportLunasOnline: true,
        exportLunas: true,
        exportLunasNow: true,
        exportBelum: true,
        exportAll: true,

        exportOpen: false,



        bulanFilter: null,
        bulanFilterNama: null,
        tahunFilter: null,
        loading: true,
        modalDetail: false,
        modalData: null,
        modalFilter: false,
        area: [],
        areaPilih: null,
        areaPilihNama: null,

        modalBulan: false,
        modalTahun: false,
        bulan: [],

        tanggal: null,
        
        admin: [],
        adminID: null,
        adminNama: null,

        paket: [],
        paketID: null,
        paketNama: null,

        type: null,

        isCari: false,
        
        judulDoc: '',
        nameDoc: '',
        json_fieldspelanggan: {
          "No" : 'no',
          "ID" : 'id',
          'Nama': 'nama',
          'Telepon': 'telepon',
          'PPOE': 'ppoe',
          'Paket': 'paket',
          'Area': 'area',
          'Alamat': 'alamat',
          'Biaya': 'biaya',
          'Tanggal Tagihan': 'tanggal',
          'Rincian Tambahan 1': 'r1',
          'Biaya Tambahan 1': 'b1',
          'Rincian Tambahan 2': 'r2',
          'Biaya Tambahan 2': 'b2',
          'Diskon': 'diskon',
          'PPN': 'ppn',
          'Total Bayar': 'total',
          'Bulan Tagihan': 'bulantagihan',
          'Lat Long': 'latlong',
          'NIK': 'nik',
          'Tanggal Bayar': 'tglbayar',
          'Admin By': 'admin',
          'Via': 'via'
        },
        json_datapelanggan: [],
        json_metapelanggan: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        
        json_fieldspelangganinvoice: {
          "No" : 'no',
          'Jam': 'jam',
          'Tanggal': 'tanggal',
          'Info': 'info',
          'Transaksi': 'transaksi',
          'Jumlah': 'jumlah',
          'Saldo': 'saldo'
        },
        json_datapelangganinvoice: [],
        json_metapelangganinvoice: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        
        json_fieldspembukuan: {
          "No" : 'no',
          "Keterangan" : 'keterangan',
          'Jumlah': 'jumlah',
          'Jam': 'jam',
          'Tanggal': 'tanggal',
          'Oleh': 'by',
          'Transaksi': 'type',
          'Kategori': 'kategori'
        },
        json_datapembukuan: [],
        json_metapembukuan: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        
        json_fieldspelangganOnly: {
          //"No" : 'no',
          'nama': 'nama',
          'telepon': 'telepon',
          'ppoe': 'ppoe',
          'tambahan': 'r1',
          'biaya': 'b1',
          'tambahan_2': 'r2',
          'biaya_2': 'b2',
          'diskon': 'diskon',
          'tanggal': 'tanggal',
          'area': 'area',
          'paket_nama': 'paket',
          'paket_tarif': 'biaya',
          'alamat': 'alamat',
          "ID" : 'id',
          'PPN': 'ppn',
          'Total Bayar': 'total',
          'Bulan Tagihan': 'bulantagihan',
          'Lat Long': 'latlong',
          'NIK': 'nik',
          'Tanggal Bayar': 'tglbayar',
          'Admin By': 'admin',
          'Via': 'via',
          'Tanggal Register': 'tanggal_register',
          'Mikrotik': 'mikrotik',
          'Modem': 'modem',
          'ODP': 'odp'
        },
        json_datapelangganOnly: [],
        json_metapelangganOnly: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],

        pageExport: 0,
        dataExportAll: [],
        dataExportAllshow: false,
        dataExportBelum: [],
        dataExportBelumshow: false,
        dataExportLunasNow: [],
        dataExportLunasNowShow: false,
        dataExportLunas: [], // transaksi cash
        dataExportLunasShow: false,
        dataExportLunasOnline: [], // transaksi online
        dataExportLunasOnlineShow: false,

        
        dataExportPembukuan: [],
        pageExportPembukuan: 0,
        dataExportPembukuanShow: false,
    })

    const btn = {
      pilihArea(id,nama) {
        console.log(nama);

        dataAll.areaPilih = id;
        dataAll.areaPilihNama = nama;
      },
      pilihAdmin(id,nama) {
        dataAll.adminID = id, dataAll.adminNama = nama;
      },
      pilihPaket(id,nama) {
        dataAll.paketID = id, dataAll.paketNama = nama;
      },
      resetFilter() {
        dataAll.isCari = false;
        dataAll.areaPilih = null,
        dataAll.areaPilihNama = null,
        dataAll.adminID = null,
        dataAll.tanggal = null,
        dataAll.adminNama = null,
        dataAll.paketID = null,
        dataAll.paketNama = null;
      },
      pilihBulan(id, nama) {
        dataAll.bulanFilter = id;
        dataAll.bulanFilterNama = nama;
      },
      CariIsolir(status) {

        /*
        let data = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          type: status,
          bulan: dataAll.bulanFilter, 
          tahun: dataAll.tahunFilter
        }
        */
       
        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', status);
        data.append('bulan', dataAll.bulanFilter);
        data.append('tahun', dataAll.tahunFilter);
        
        var apiUrl = inter.getUserIsolir();
        //console.log(JSON.stringify(data));

        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          if (x.status) {
            dataAll.type = status;

            var judul = "Pelanggan - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
            if (status == 'isolir') { // ISOLIR
              judul = "Pelanggan Isolir - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
            }

            if (status == "isolir") {
              btn.parseExcelAllOnly(x.data, judul, status);
            }
          } else {
            
          }
        })

      },
      CariMulti(status) {
        // CEK POLIND DULU
        
        var judul = "";
        
        if (status == 'belum') {

          dataAll.type = status;

          judul = "Belum Bayar - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

          let polling = JSON.parse(sessionStorage.getItem("export_belum_getData"));
          
          if(polling != null) {
            let time = polling.time; // ulululu
            let d = polling.d;

            this.page = polling.page;

            let sudah5menit = myGlobal.cek5menit(time,15);
            if(sudah5menit == "belum") {
              this.loading = false;
              myGlobal.loger("BELUM 15 export_belum_getData");

              dataAll.dataExportBelum = d;
              dataAll.dataExportBelumshow = true;
              
              btn.parseExcel(d, judul, status);
              
              return false;
            }
          }

        } else if (status == 'lunas') { // transaksi cash
          dataAll.type = status;

          judul = "Transaksi Cash - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

          let polling = JSON.parse(sessionStorage.getItem("export_lunas_getData"));
          
          if(polling != null) {
            let time = polling.time;
            let d = polling.d;

            this.page = polling.page;

            let sudah5menit = myGlobal.cek5menit(time,15);
            if(sudah5menit == "belum") {
              this.loading = false;
              myGlobal.loger("BELUM 15 export_lunas_getData");

              dataAll.dataExportLunas = d;
              dataAll.dataExportLunasShow = true;
              
              btn.parseExcel(d, judul, status);
              
              return false;
            }
          }

        } else if (status == 'lunasnow') { // transaksi cash
          dataAll.type = status;
          judul = "Lunas Bayar - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

          let polling = JSON.parse(sessionStorage.getItem("export_lunasnow_getData"));
          
          if(polling != null) {
            let time = polling.time;
            let d = polling.d;

            this.page = polling.page;

            let sudah5menit = myGlobal.cek5menit(time,15);
            if(sudah5menit == "belum") {
              this.loading = false;
              myGlobal.loger("BELUM 15 export_lunasnow_getData");

              dataAll.dataExportLunasNow = d;
              dataAll.dataExportLunasNowShow = true;
              
              btn.parseExcel(d, judul, status);
              
              return false;
            }
          }

        } else if (status == 'lunas_online') { // transaksi online
          dataAll.type = status;
          judul = "Transaksi Online - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

          let polling = JSON.parse(sessionStorage.getItem("export_lunas_online_getData"));
          
          if(polling != null) {
            let time = polling.time;
            let d = polling.d;

            this.page = polling.page;

            let sudah5menit = myGlobal.cek5menit(time,15);
            if(sudah5menit == "belum") {
              this.loading = false;
              myGlobal.loger("BELUM 15 export_lunas_online_getData");

              dataAll.dataExportLunasOnline = d;
              dataAll.dataExportLunasOnlineShow = true;
              
              btn.parseExcel(d, judul, status);
              
              return false;
            }
          }

        } else if (status == 'berhenti') { // berhenti
          dataAll.type = status;
          judul = "Pelanggan Berhenti - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

          let polling = JSON.parse(sessionStorage.getItem("export_berhenti_getData"));
          
          if(polling != null) {
            let time = polling.time;
            let d = polling.d;

            this.page = polling.page;

            let sudah5menit = myGlobal.cek5menit(time,15);
            if(sudah5menit == "belum") {
              this.loading = false;
              myGlobal.loger("BELUM 15 export_berhenti_getData");
              
              btn.parseExcel(d, judul, status);
              
              return false;
            }
          }

        } else if (status == 'isolir') { // ISOLIR
          dataAll.type = status;
          judul = "Pelanggan Isolir - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

          let polling = JSON.parse(sessionStorage.getItem("export_isolir_getData"));
          
          if(polling != null) {
            let time = polling.time;
            let d = polling.d;

            this.page = polling.page;

            let sudah5menit = myGlobal.cek5menit(time,15);
            if(sudah5menit == "belum") {
              this.loading = false;
              myGlobal.loger("BELUM 15 export_isolir_getData");
              
              btn.parseExcel(d, judul, status);
              
              return false;
            }
          }

        } else {
          dataAll.type = status;

          // ALL 
          var judul = "Pelanggan - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter; // JUDUL ALL
          
          let polling = JSON.parse(sessionStorage.getItem("export_all_getData"));
          
          if(polling != null) {
            let time = polling.time;
            let d = polling.d;

            this.page = polling.page;

            let sudah5menit = myGlobal.cek5menit(time,5);
            if(sudah5menit == "belum") {
              this.loading = false;
              myGlobal.loger("BELUM 15 export_all_getData");

              dataAll.dataExportAll = d;
              dataAll.dataExportAllshow = true;
              
              btn.parseExcelAllOnly(d, judul, status);
              
              return false;
            }
          }

        }

        console.log("ambil baru");

        //console.log(status);

        let data = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          type: status,
          bulan: dataAll.bulanFilter, 
          tahun: dataAll.tahunFilter, 
          admin: dataAll.adminNama,
          adminid: dataAll.adminID,
          area: dataAll.areaPilih,
          paket: dataAll.paketID,
          page: dataAll.pageExport,
          buat: "export"
        }

        if (dataAll.tanggal != null) { 
          data["tanggal"] = moment(dataAll.tanggal).format('DD'),
          data["sampai"] = moment(dataAll.tanggal).format('DD')
        }

        if (status == "all") {
          data["nik"] = "ya"; // export pake nik
          data["mikrotik"] = "ya"; // export pake mikrotik
          data["odp"] = "ya"; // export pake nik
        }
        if (status == "berhenti") {
          data["odp"] = "ya"; // export pake nik
        }
        
        var apiUrl = inter.getUserCariMultiFilter();
        
        // console.log(JSON.stringify(data));

        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          console.log("hasil "+dataAll.pageExport)

          if (x.status) {
            dataAll.type = status;

            var judul = "Pelanggan - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
            
            if (status == 'berhenti') { // berhenti
              judul = "Pelanggan Berhenti - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

              // PASANG DATA BARU
              let waktu = myGlobal.timeNow();
              let polling = {
                time: waktu,
                d: x.data,
                bulan: sessionStorage.getItem('bulanIdBase')
              }
              sessionStorage.setItem("export_berhenti_getData", JSON.stringify(polling));

            } else if (status == 'isolir') { // ISOLIR

              judul = "Pelanggan Isolir - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;

              // PASANG DATA BARU
              let waktu = myGlobal.timeNow();
              let polling = {
                time: waktu,
                d: x.data,
                bulan: sessionStorage.getItem('bulanIdBase')
              }
              sessionStorage.setItem("export_isolir_getData", JSON.stringify(polling));
            }

            // LOOPINGNYA DISINI /////////////////////////////////////////////////////////////////

            if (status == "all") {

              if(dataAll.dataExportAll.length == 0) {
                dataAll.dataExportAll = x.data;
                // console.log(JSON.stringify(dataAll.dataExport));
              } else {
                dataAll.dataExportAll.push(...x.data);
              }
              
              dataAll.pageExport = dataAll.pageExport + 1;

              //console.log(dataAll.pageExport);

              setTimeout(
                function() {
                  btn.CariMulti(status);
                }
              , 2000);

            } else if (status == "belum") {
              judul = "Belum Bayar - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
              
              if(dataAll.dataExportBelum.length == 0) {
                dataAll.dataExportBelum = x.data;
                // console.log(JSON.stringify(dataAll.dataExport));
              } else {
                dataAll.dataExportBelum.push(...x.data);
              }
              
              dataAll.pageExport = dataAll.pageExport + 1;

              //console.log(dataAll.pageExport);

              setTimeout(
                function() {
                  btn.CariMulti(status);
                }
              , 2000);

            } else if (status == 'lunasnow') { // transaksi cash

              judul = "Lunas Bayar - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
              
              if(dataAll.dataExportLunasNow.length == 0) {
                dataAll.dataExportLunasNow = x.data;
                // console.log(JSON.stringify(dataAll.dataExport));
              } else {
                dataAll.dataExportLunasNow.push(...x.data);
              }
              
              dataAll.pageExport = dataAll.pageExport + 1;

              //console.log(dataAll.pageExport);

              setTimeout(
                function() {
                  btn.CariMulti(status);
                }
              , 2000);

            } else if (status == 'lunas') { // transaksi cash
              
              if(dataAll.dataExportLunas.length == 0) {
                dataAll.dataExportLunas = x.data;
                // console.log(JSON.stringify(dataAll.dataExport));
              } else {
                dataAll.dataExportLunas.push(...x.data);
              }
              
              dataAll.pageExport = dataAll.pageExport + 1;

              //console.log(dataAll.pageExport);

              setTimeout(
                function() {
                  btn.CariMulti(status);
                }
              , 2000);

            } else if (status == 'lunas_online') { // transaksi cash
              
              if(dataAll.dataExportLunasOnline.length == 0) {
                dataAll.dataExportLunasOnline = x.data;
                // console.log(JSON.stringify(dataAll.dataExport));
              } else {
                dataAll.dataExportLunasOnline.push(...x.data);
              }
              
              dataAll.pageExport = dataAll.pageExport + 1;

              //console.log(dataAll.pageExport);

              setTimeout(
                function() {
                  btn.CariMulti(status);
                }
              , 2000);

            } else if (status == "berhenti") {
              btn.parseExcelAllOnly(x.data, judul, status);
            } else if (status == "isolir") {
              btn.parseExcelAllOnly(x.data, judul, status);
            } else {


              btn.parseExcel(x.data, judul, status);


            }
            
              /*
            // PASANG DATA BARU
            let waktu = myGlobal.timeNow();
            let polling = {
              time: waktu,
              d: dataAll.dataExportAll,
              bulan: sessionStorage.getItem('bulanIdBase')
            }
              */

          } else { // TIDAK ADA DATA LAGIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII
            // pasang ke excel ketika tidak ada data lagi

            if (status == "all") {

              dataAll.dataExportAllshow = true;

              judul = "Pelanggan - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
              btn.parseExcelAllOnly(dataAll.dataExportAll, judul, status);
              
              let waktu = myGlobal.timeNow();
              let polling = {
                time: waktu,
                d: dataAll.dataExportAll,
                bulan: sessionStorage.getItem('bulanIdBase')
              }

              sessionStorage.setItem("export_all_getData", JSON.stringify(polling));

            } else if (status == "belum") {

              dataAll.dataExportBelumshow = true;

              judul = "Belum Bayar - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
              btn.parseExcel(dataAll.dataExportBelum, judul, status);
              
              let waktu = myGlobal.timeNow();
              let polling = {
                time: waktu,
                d: dataAll.dataExportBelum,
                bulan: sessionStorage.getItem('bulanIdBase')
              }

              sessionStorage.setItem("export_belum_getData", JSON.stringify(polling));

            } else if (status == "lunasnow") {

              dataAll.dataExportLunasNowShow = true;
              judul = "Lunas Bayar - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
              btn.parseExcel(dataAll.dataExportLunasNow, judul, status);

              // PASANG DATA BARU
              let waktu = myGlobal.timeNow();
              let polling = {
                time: waktu,
                d: dataAll.dataExportLunasNow,
                bulan: sessionStorage.getItem('bulanIdBase')
              }

              sessionStorage.setItem("export_lunasnow_getData", JSON.stringify(polling));

            } else if (status == 'lunas') { // transaksi cash

              judul = "Transaksi Cash - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
              dataAll.dataExportLunasShow = true;
              btn.parseExcel(dataAll.dataExportLunas, judul, status);

              // PASANG DATA BARU
              let waktu = myGlobal.timeNow();
              let polling = {
                time: waktu,
                d: dataAll.dataExportLunas,
                bulan: sessionStorage.getItem('bulanIdBase')
              }
              sessionStorage.setItem("export_lunas_getData", JSON.stringify(polling));

            } else if (status == 'lunas_online') { // transaksi online

              judul = "Transaksi Online - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
              dataAll.dataExportLunasOnlineShow = true;
              btn.parseExcel(dataAll.dataExportLunasOnline, judul, status);

              // PASANG DATA BARU
              let waktu = myGlobal.timeNow();
              let polling = {
                time: waktu,
                d: dataAll.dataExportLunasOnline,
                bulan: sessionStorage.getItem('bulanIdBase')
              }
              sessionStorage.setItem("export_lunas_online_getData", JSON.stringify(polling));

            } else if (status == "berhenti") {
            } else if (status == "isolir") {
            } else {

              btn.parseExcel(x.data, judul, status);

            }
            
          }
        })
      },
      parseExcelInvoice(x,judul) {
        
        var data = x;
        var values = [];
        var i;
        for (i = 0; i < data.length; i++) {
          var saldoafter = myGlobal.ribu(data[i].saldo_after);
          var stat = "(Sukses)";
          var an = '';
          if (data[i].acc_stat == 'reject') {
            stat = "(Di tolak)";
            saldoafter = '-';
          } else {
            if (data[i].metadata != null) {
              var datac = JSON.parse(data[i].metadata);
              an = datac.bank_code + " " + datac.account_number + " " + datac.account_holder_name + " " + datac.amount;
            }
          }
          var info = "Withdraw #"+data[i].id+" "+stat+" "+an;
          if (data[i].keterangan == 'masuk') {
            info = "#"+ data[i].h_id + " - " + data[i].unama + " - " + data[i].uwa;
          }
          var item1 = {
            "no" : i+1,
            'jam' : data[i].jam, //this.tglIndo(data[i].due_date)
            'tanggal': data[i].tanggal,
            'info': info,
            'transaksi': data[i].keterangan,
            'jumlah':  data[i].jumlah,
            'saldo': saldoafter
          };
          values.push(item1);
        }

        dataAll.json_datapelangganinvoice = values;          
        dataAll.judulDoc = [judul+" - Per "+myGlobal.tglIndo(new Date)];
        dataAll.nameDoc = judul+" - Per "+myGlobal.tglIndo(new Date)+".xls";

      },
      parseExcelPembukuan(x,judul) {
        myGlobal.loger(x);

        var data = x;
        var values = [];
        var i;
        for (i = 0; i < data.length; i++) {
          var stat = null;
          if (data[i].type == 'masuk') {
            stat = "Masuk";
          } else {
            stat = "keluar";
          }
          var item1 = {
            "no" : i+1,
            'keterangan' : data[i].keterangan, 
            'jumlah': data[i].jumlah,
            'jam': data[i].jam,
            'tanggal': data[i].tanggal,
            'by': data[i].by,
            'type': stat,
            'kategori': data[i].kategori
          };
          values.push(item1);
        }

        dataAll.json_datapembukuan = values;          
        dataAll.judulDoc = [judul+" - Per "+myGlobal.tglIndo(new Date)];
        dataAll.nameDoc = judul+" - Per "+myGlobal.tglIndo(new Date)+".xls";

      },
      parseExcelWithdraw(x,judul) {
        var data = x;
        var values = [];
        var i;
        for (i = 0; i < data.length; i++) {
          var saldoafter = myGlobal.ribu(data[i].saldo_after);
          var stat = "(Sukses)";
          var an = '';
          if (data[i].acc_stat == 'reject') {
            stat = "(Di tolak)";
            saldoafter = '-';
          } else {
            var datac = JSON.parse(data[i].metadata);
            an = datac.bank_code + " " + datac.account_number + " " + datac.account_holder_name + " " + datac.amount;
          }
          var info = "Withdraw #"+data[i].id+" "+stat+" "+an;
          if (data[i].keterangan == 'masuk') {
            info = "#"+ data[i].h_id + " - " + data[i].unama + " - " + data[i].uwa;
          }
          var item1 = {
            "no" : i+1,
            'jam' : data[i].jam, 
            'tanggal': data[i].tanggal,
            'info': info,
            'transaksi': data[i].keterangan,
            'jumlah': data[i].jumlah,
            'saldo': saldoafter
          };
          values.push(item1);
        }

        dataAll.json_datapelangganinvoice = values;          
        dataAll.judulDoc = [judul+" - Per "+myGlobal.tglIndo(new Date)];
        dataAll.nameDoc = judul+" - Per "+myGlobal.tglIndo(new Date)+".xls";

      },
      parseExcel(x,judul,status) {

        myGlobal.loger(x);

        var data = x;
        var values = [];
        var i;
        for (i = 0; i < data.length; i++) {
          
            var telepon = data[i].user.wa;
            if (telepon.charAt(0) == "0") {
              telepon = "62"+telepon.substring(1);
            } else if (telepon.charAt(0) == "8") {
              telepon = "62"+telepon;
            }
            var bulantagihan = dataAll.tahunFilter+"-"+dataAll.bulanFilter+"-01";
            if (status == 'lunas') { // transaksi cash
              bulantagihan = data[i].user.tanggal;
            }
            if (status == 'lunas_online') { // transaksi online
              bulantagihan = data[i].user.tanggal;
            }
            
            var ppn = myGlobal.isNull(myGlobal.PPN());
            var totalTod = null;
            var r1 = null,b1 = null,r2 = null, b2 = null, diskon = null, admin = null, tglbayar = null, via = null;

            if (status == "belum") {
              totalTod = ( 
                      ( 
                        parseInt(data[i].user.ptarif) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                      ) + 
                      (  
                        ( 
                          ( parseInt(data[i].user.ptarif) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                          ) 
                        / 100 )
                      ) * parseInt( ppn )   ) - parseInt(myGlobal.isNull(data[i].user.diskon)
                    );

              r1 = data[i].user.biaya_rincian;
              b1 = data[i].user.biaya_tambahan;
              r2 = data[i].user.biaya_rincian_2;
              b2 = data[i].user.biaya_tambahan_2;
              diskon = data[i].user.diskon;
            } else if (status == "all") {
              totalTod = ( 
                      ( 
                        parseInt(data[i].user.ptarif) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                      ) + 
                      (  
                        ( 
                          ( parseInt(data[i].user.ptarif) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                          ) 
                        / 100 )
                      ) * parseInt( ppn )   ) - parseInt(myGlobal.isNull(data[i].user.diskon)
                    );

              r1 = data[i].user.biaya_rincian;
              b1 = data[i].user.biaya_tambahan;
              r2 = data[i].user.biaya_rincian_2;
              b2 = data[i].user.biaya_tambahan_2;
              diskon = data[i].user.diskon;
            } else {
              // lunas, lunasnow, lunas_online
              totalTod = data[i].user.paket_tarif;

              r1 = data[i].user.rincian1;
              b1 = data[i].user.biaya1;
              r2 = data[i].user.rincian2;
              b2 = data[i].user.biaya2;
              diskon = data[i].user.diskon;
              admin = data[i].user.by_admin;
              via = data[i].user.via;
              tglbayar = myGlobal.tglIndo(data[i].user.bayar_tanggal);
            }

            var item1 = {
                "no" : i+1,
                'id' : data[i].user.fake_id, //this.tglIndo(data[i].due_date)
                'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                'telepon': telepon,
                'ppoe': data[i].user.ppoe,
                'paket': data[i].user.pnama,
                'area': data[i].area,
                'alamat': data[i].user.alamat,
                'biaya': data[i].user.ptarif,
                'ppoe': data[i].user.ppoe,
                'tanggal': data[i].user.tanggal_tagihan,
                'r1': r1,
                'b1': b1,
                'r2': r2,
                'b2': b2,
                'diskon': diskon, 
                'ppn': ppn+"%", 
                'bulantagihan': myGlobal.BulanOnly(bulantagihan),
                'latlong': data[i].user.lat+", "+data[i].user.lng,
                'total': totalTod,
                  
                'nik': data[i].user.nik,
                'admin': admin,
                'tglbayar': tglbayar,
                'via': via
            };
            values.push(item1);
        }

        dataAll.json_datapelanggan = values;          
        dataAll.judulDoc = [judul+" - Per "+myGlobal.tglIndo(new Date)];
        dataAll.nameDoc = judul+" - Per "+myGlobal.tglIndo(new Date)+".xls";
      },
      parseExcelAllOnly(x,judul,status) {
        
        var data = x;
        
        var values = [];
        var i;
        for (i = 0; i < data.length; i++) {
          
            var telepon = data[i].user.wa;
            if (telepon.charAt(0) == "0") {
              telepon = "62"+telepon.substring(1);
            } else if (telepon.charAt(0) == "8") {
              telepon = "62"+telepon;
            }
            var bulantagihan = dataAll.tahunFilter+"-"+dataAll.bulanFilter+"-01";
            if (status == 'lunas') { // transaksi cash
              bulantagihan = data[i].user.tanggal;
            }
            if (status == 'lunas_online') { // transaksi online
              bulantagihan = data[i].user.tanggal;
            }
            
            var ppn = myGlobal.isNull(myGlobal.PPN());
            var totalTod = null;
            var r1 = null,b1 = null,r2 = null, b2 = null, diskon = null, admin = null, tglbayar = null, via = null;

            if (status == "belum") {
              totalTod = ( 
                      ( 
                        parseInt(data[i].user.ptarif) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                      ) + 
                      (  
                        ( 
                          ( parseInt(data[i].user.ptarif) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                          ) 
                        / 100 )
                      ) * parseInt( ppn )   ) - parseInt(myGlobal.isNull(data[i].user.diskon)
                    );

              r1 = data[i].user.biaya_rincian;
              b1 = data[i].user.biaya_tambahan;
              r2 = data[i].user.biaya_rincian_2;
              b2 = data[i].user.biaya_tambahan_2;
              diskon = data[i].user.diskon;
            } else if (status == "all") {
              totalTod = ( 
                      ( 
                        parseInt(data[i].user.ptarif) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                      ) + 
                      (  
                        ( 
                          ( parseInt(data[i].user.ptarif) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan)) + 
                            parseInt(myGlobal.isNull(data[i].user.biaya_tambahan_2)) 
                          ) 
                        / 100 )
                      ) * parseInt( ppn )   ) - parseInt(myGlobal.isNull(data[i].user.diskon)
                    );

              r1 = data[i].user.biaya_rincian;
              b1 = data[i].user.biaya_tambahan;
              r2 = data[i].user.biaya_rincian_2;
              b2 = data[i].user.biaya_tambahan_2;
              diskon = data[i].user.diskon;
            } else {
              // lunas, lunasnow, lunas_online
              totalTod = data[i].user.paket_tarif;

              r1 = data[i].user.rincian1;
              b1 = data[i].user.biaya1;
              r2 = data[i].user.rincian2;
              b2 = data[i].user.biaya2;
              diskon = data[i].user.diskon;
              admin = data[i].user.by_admin;
              via = data[i].user.via;
              tglbayar = myGlobal.tglIndo(data[i].user.bayar_tanggal);
            }

            var item1 = {
                //"no" : i+1,
                'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                'telepon': telepon,
                'ppoe': data[i].user.ppoe,
                'r1': r1,
                'b1': b1,
                'r2': r2,
                'b2': b2,
                'diskon': diskon, 
                'tanggal': data[i].user.tanggal_tagihan,
                'area': data[i].area,
                'paket': data[i].user.pnama,
                'biaya': data[i].user.ptarif,
                'alamat': data[i].user.alamat,
                'id' : data[i].user.fake_id, //this.tglIndo(data[i].due_date)
                'ppn': ppn+"%", 
                'bulantagihan': myGlobal.BulanOnly(bulantagihan),
                'latlong': data[i].user.lat+", "+data[i].user.lng,
                'total': totalTod,
                'nik': data[i].user.nik,
                'odp': data[i].user.odp,
                'admin': admin,
                'tglbayar': tglbayar,
                'via': via,
                'tanggal_register': myGlobal.tglIndo(data[i].user.tanggal_register),
                'mikrotik': data[i].user.mikrotik_nama,
                'modem': data[i].user.modem_info
            };
            values.push(item1);
        }

        dataAll.json_datapelangganOnly = values;          
        dataAll.judulDoc = [judul+" - Per "+myGlobal.tglIndo(new Date)];
        dataAll.nameDoc = judul+" - Per "+myGlobal.tglIndo(new Date)+".xls";
        },
      startDownload() {
        //alert("start")
      },
      ExportMasuk() {
        let data = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          bulan: dataAll.bulanFilter, 
          tahun: dataAll.tahunFilter, 
          page: "all"
        }
        
        var apiUrl = inter.HistorySaldo();

        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          if (x.status) {
            var judul = "Invoice - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
            btn.parseExcelInvoice(x.data, judul);
          } else {
            
          }
        })
      },
      ExportWithdraw() {
        let data = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          bulan: dataAll.bulanFilter, 
          tahun: dataAll.tahunFilter, 
          page: "all"
        }
        
        var apiUrl = inter.HistoryWithdraw();

        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          if (x.status) {
            var judul = "Invoice - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
            btn.parseExcelWithdraw(x.data, judul);
          } else {
            
          }
        })
      },
      Pembukuan() {
        let data = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          bulan: dataAll.bulanFilter, 
          tahun: dataAll.tahunFilter, 
          page: dataAll.pageExportPembukuan,
          kategori: "all"
        }
        
        var apiUrl = inter.Pengeluaran();

        myGlobal.call(data,apiUrl).then(x => {
          //console.log("Pembukuan");
          //console.log(JSON.stringify(x)); 

          if (x.status) {
            
            if(dataAll.dataExportPembukuan.length == 0) {
              dataAll.dataExportPembukuan = x.data;
              // console.log(JSON.stringify(dataAll.dataExport));
            } else {
              dataAll.dataExportPembukuan.push(...x.data);
            }
            
            dataAll.pageExportPembukuan = dataAll.pageExportPembukuan + 1;

            //console.log(dataAll.pageExport);

            setTimeout(
              function() {
                btn.Pembukuan();
              }
            , 2000);

          } else {
            
            var judul = "Pembukuan - "+dataAll.bulanFilterNama+ " " + dataAll.tahunFilter;
            dataAll.dataExportPembukuanShow = true;
            btn.parseExcelPembukuan(dataAll.dataExportPembukuan, judul);

            // alert("Tidak ada data");


          }
        })
      }

    }

    const theGet = {
      data: reactive({
        List: [],
      }),
      getArea() {
        // for filter
        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('type', "belum");
        data.append('bulan', sessionStorage.getItem('bulanIdBase'));
        data.append('tahun', sessionStorage.getItem('tahunBase'));
        
        var apiUrl = inter.ListArea(); //'ListArea'
        myGlobal.call(data,apiUrl).then(x => {
          // myGlobal.loger(x)
          if (x.status) {
            dataAll.area = x.data;
          } else {
            //alert(x.pesan);
          }
        })
      },
      getAdmin() {
        console.log("get Area");

        var data = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          is: "tagih"
        }
        
        var apiUrl = inter.AdminList();
        myGlobal.call(data,apiUrl).then(x => {
          if (x.status) {
            dataAll.admin = x.data;
          } else {
            //alert(x.pesan);
          }

        })
      },
      getPaket() {
        this.isCari = false;

        var data = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        }
        
        var apiUrl = inter.ListPaket();
        myGlobal.call(data,apiUrl).then(x => {
          if (x.status) {
            dataAll.paket = x.data;
          } else {
            //alert(x.pesan);
          }
        })
      },
      customFormatter (date) {
        return moment(date).format('DD');
      },
    }
    return {
      dataAll,
      myGlobal,
      theGet,
      btn
    }
  },
  mounted () {
    document.title = "Export";

    this.dataAll.namaQ = sessionStorage.getItem('admin');

    this.dataAll.bulanFilterNama = myGlobal.getBulanNow(); 
    this.dataAll.bulanFilter = myGlobal.getBulan(); 
    this.dataAll.tahunFilter = myGlobal.getTahunNow();
    
    this.theGet.getArea();
    this.theGet.getAdmin();
    this.theGet.getPaket();
    
    this.dataAll.bulan = [
      {
        "id": "01",
        "nama": "Januari"
      },
      {
        "id": "02",
        "nama": "Februari"
      },
      {
        "id": "03",
        "nama": "Maret"
      },
      {
        "id": "04",
        "nama": "April"
      },
      {
        "id": "05",
        "nama": "Mei"
      },
      {
        "id": "06",
        "nama": "Juni"
      },
      {
        "id": "07",
        "nama": "Juli"
      },
      {
        "id": "08",
        "nama": "Agustus"
      },
      {
        "id": "09",
        "nama": "September"
      },
      {
        "id": "10",
        "nama": "Oktober"
      },
      {
        "id": "11",
        "nama": "November"
      },
      {
        "id": "12",
        "nama": "Desember"
      }
    ];

    // Mengambil jam saat ini (format 0-23)
    const jamSekarang = new Date().getHours();

    // Cek apakah jam lebih dari atau sama dengan 18 (6 sore)
    if (jamSekarang >= 18) {
        this.exportOpen = true;
        // Masukkan kode Anda di sini
    } else {
        //this.exportOpen = false;
        this.exportOpen = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
  display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/export/main.vue